import dayjs from 'dayjs'
import React from 'react'

interface Props {
  date: string
}

export const DateDisplay = ({ date }: Props) => {
  // Re-parse date in case what was passed was a string
  return <>{dayjs(date).format('MMMM YYYY')}</>
}
